import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { TDataSourceCall, TWorkflowDefinition } from '@commenda/types';
import { AddEditDataSourceForm } from '../forms/AddEditDataSourceForm';

export const AddEditDataSourceModal = ({
  isOpen,
  onClose,
  dataSource,
  onSave,
  workflowDefinition,
}: {
  isOpen: boolean;
  onClose: () => void;
  dataSource: TDataSourceCall | null;
  onSave: (dataSource: TDataSourceCall) => void;
  workflowDefinition: TWorkflowDefinition;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl flex flex-col overflow-hidden">
        <DialogHeader>
          <DialogTitle>
            {dataSource ? 'Edit Data Source' : 'Add Data Source'}
          </DialogTitle>
        </DialogHeader>
        <div className="grow overflow-auto max-h-[80vh]">
          <AddEditDataSourceForm
            dataSource={dataSource}
            onSave={(ds) => {
              onSave(ds);
              onClose();
            }}
            workflowDefinition={workflowDefinition}
            onCancel={onClose}
            formContentClassName="p-6"
            formFooterClassName="p-6"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
